import React, { useState, useEffect, useRef } from "react";
import { FaAngleUp } from "react-icons/fa6";
import { Tooltip } from "react-tooltip";
import { ChangingLanguage } from "../ChangingLanguage";
import { useAppSelector } from "../../hook";
import { useTranslation } from "react-i18next";

function Header() {
  const [open, setOpen] = useState(false);
  const userData: any = useAppSelector((state) => state.auth.userData);
  const { t, i18n } = useTranslation();
  const isSuperadmin = userData && userData.isSuperadmin;
  const profileRef = useRef<HTMLDivElement>(null);

  // Закрытие тултипа профиля при клике вне его области
  useEffect(() => {
    if (!open) {
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      
      if (profileRef.current && !profileRef.current.contains(target)) {
        // Проверяем, что клик был не на самом тултипе
        const tooltip = document.querySelector('[id="user-profile"]');
        if (!tooltip || !tooltip.contains(target)) {
          setOpen(false);
        }
      }
    };

    // Небольшая задержка, чтобы не закрыть сразу после открытия
    const timeoutId = setTimeout(() => {
      document.addEventListener('click', handleClickOutside, true);
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [open]);

  return (
    <header className="flex flex-row items-center grow-0 flex-none h-16 pt-5 mb-5 w-full justify-end">
      <div className="flex flex-col px-3">
        <span className="text-mainColor font-light text-lg" style={{ fontFamily: 'Roboto', fontWeight: 300 }}>
          {userData.firstName || userData.firstname
            ? `${userData.firstName || userData.firstname} ${userData.lastName || userData.lastname || ""}`
            : "Админ"}
        </span>

      </div>
      <div className="relative" ref={profileRef}>
        <button
          onClick={!isSuperadmin ? (e) => {
            e.stopPropagation();
            setOpen(!open);
          } : undefined}
          className="flex flex-row items-center"
          data-tooltip-id={!isSuperadmin ? "user-profile" : undefined}
          type="button"
        >
          <div className="relative flex justify-center items-center align-middle mx-auto object-cover rounded-full h-12 w-12 bg-white text-gray-400">
            <span className="text-mainColor font-bold" style={{ fontFamily: 'Roboto' }}>
              {" "}
              {(userData.firstName || userData.firstname) ? `${(userData.firstName || userData.firstname)[0]}` : "А"}
            </span>
          </div>
          {!isSuperadmin && (
            <span
              className={`cursor-pointer px-2  text-gray-600 ${!open && "rotate-180"}`}
            >
              <FaAngleUp />
            </span>
          )}
        </button>
        {!isSuperadmin && (
          <Tooltip
            id="user-profile"
            className="bg-white rounded duration-200 mt-2"
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              color: "#222",
              margin: "0",
              padding: "0",
              zIndex: "100",
            }}
            isOpen={open}
            clickable={true}
            noArrow={true}
            opacity={1}
            place={"bottom-end"}
            afterShow={() => setOpen(true)}
            afterHide={() => setOpen(false)}
          >
            <ul id={`dropdown-example-user-profile`}>
              
                <li
                  className="flex rounded-md p-2 cursor-pointer hover:bg-light-white items-center gap-x-4
                hover:bg-mainColor hover:text-white"
                >
                  <a className="origin-left duration-200"
                  href="/profile"
                  >
                    {t("submenu.profile")}
                  </a>
                </li>
              
            </ul>
          </Tooltip>
        )}
      </div>
      <img
        src="/icons/bell.svg"
        className="mx-2 duration-200 group-hover:brightness-200 group-hover:invert-1"
      />
      <div className="bg-white p-2 ml-2 rounded ">
        <ChangingLanguage onlyDesktop={true} />
      </div>
    </header>
  );
}

Header.propTypes = {};

export default Header;
